var _defs, _path, _path2, _g, _g2, _path3, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoSimple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 537.15 443.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient-2);}.cls-2{fill:url(#linear-gradient-14);}.cls-3{fill:url(#linear-gradient-6);}.cls-4{fill:url(#linear-gradient-11);}.cls-5{fill:url(#linear-gradient-10);}.cls-6{fill:#f7d649;}.cls-7{opacity:.3;}.cls-8{fill:url(#linear-gradient-5);}.cls-9,.cls-10{fill:#000072;}.cls-11{fill:url(#linear-gradient-7);}.cls-12{fill:url(#linear-gradient-9);}.cls-13{fill:url(#linear-gradient-3);}.cls-14{fill:url(#linear-gradient);}.cls-15{fill:url(#linear-gradient-4);}.cls-10{opacity:.1;}.cls-16{fill:url(#linear-gradient-8);}.cls-17{fill:url(#linear-gradient-12);}.cls-18{fill:url(#linear-gradient-13);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 156.66,
    y1: 40.99,
    x2: 369.33,
    y2: 386.99,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8957e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#8756e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#7254f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b53f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 304.03,
    y1: 59.9,
    x2: 401.26,
    y2: 59.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 316.6,
    y1: 64.77,
    x2: 375.87,
    y2: 64.77,
    gradientTransform: "translate(219.93 -264.04) rotate(58.39)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 394.66,
    y1: 137.59,
    x2: 428.98,
    y2: 175.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 399.54,
    y1: 133.19,
    x2: 433.86,
    y2: 171.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 393.76,
    y1: 299.09,
    x2: 378.71,
    y2: 276.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 396.35,
    y1: 297.4,
    x2: 381.3,
    y2: 274.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 162.2,
    y1: 66.58,
    x2: 186.46,
    y2: 99.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 161.33,
    y1: 67.23,
    x2: 185.59,
    y2: 99.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 258.1,
    y1: 332.09,
    x2: 280.46,
    y2: 373.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 259.64,
    y1: 331.26,
    x2: 282,
    y2: 372.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 97.18,
    y1: 246.77,
    x2: 134.1,
    y2: 309.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 96.41,
    y1: 247.23,
    x2: 133.33,
    y2: 309.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 239.5,
    y1: -10.12,
    x2: 484.23,
    y2: 326.6,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M475.5,221.98c0,114.65-92.94,207.6-207.6,207.6S60.31,336.63,60.31,221.98,153.25,14.38,267.9,14.38c102.52,0,187.69,74.32,204.56,172.02,1.11,6.4,1.92,12.9,2.43,19.49,.14,1.8,.26,3.6,.34,5.42,.18,3.54,.27,7.1,.27,10.68Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M452.1,224.89c-.48,42.04-15.49,81.73-42.62,113.57-2.85,3.35-5.84,6.62-8.96,9.78-1.24,1.27-2.51,2.52-3.79,3.75-35.08,33.67-81.65,52.2-131.16,52.2h-.28c-50.37-.07-98.36-19.91-133.32-54.8-2.56-2.55-5.05-5.18-7.47-7.9-.54-.61-.88-1.31-1-2.04,.32-.07,.64-.15,.96-.23,2.56-.61,5.16-1.24,7.78-1.91,3.47,3.24,7.05,6.33,10.74,9.26,32.07,25.57,71.91,39.63,113.83,39.91h1.25c44.43,0,86.59-15.66,119.97-44.38,2.7-2.32,5.34-4.74,7.93-7.23,.7-.67,1.39-1.35,2.08-2.04,32.94-32.82,51.28-75.58,51.85-120.96,0-.72,.01-1.45,.01-2.17,0-4-.14-8-.41-11.99,3.33-2.32,6.57-4.62,9.72-6.92,.81,4.41,1.45,8.85,1.91,13.31,.73,6.87,1.05,13.8,.97,20.77Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M294.09,184.55h-.04l-7.56,1.2c-.71,.11-1.35,.51-1.76,1.1-.41,.59-.56,1.3-.42,2,1.63,8.23-.05,17.27-4.49,24.18-4.92,7.66-12.66,13.13-21.81,15.41-9.07,2.26-18.43,1.07-26.35-3.34-7.89-4.4-13.39-11.46-15.49-19.9-.53-2.11-.83-4.29-.9-6.46-.02-.74-.36-1.44-.93-1.92-.58-.48-1.33-.7-2.08-.6l-7.68,1.08c-1.35,.19-2.35,1.4-2.28,2.74,.15,2.78,.56,5.57,1.24,8.29,4.86,19.55,22.99,33.62,44.09,34.2,2.8,.08,5.6-.08,8.37-.47,1.72-.24,3.44-.58,5.14-1,12.37-3.07,22.89-10.53,29.62-21.01,6.51-10.12,8.75-22.01,6.29-33.47-.29-1.35-1.58-2.24-2.96-2.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M322.18,141.62c-3.3-13.29-15.56-22.84-29.82-23.24-3.04-.09-6.09,.25-9.06,.99-8.31,2.06-15.38,7.08-19.91,14.13-4.42,6.88-5.94,14.96-4.26,22.78,.6,2.79,3.26,4.64,6.08,4.24,.03,0,.06,0,.09-.01l4.49-.71c1.46-.23,2.77-1.06,3.61-2.27,.84-1.2,1.16-2.72,.87-4.16-.78-3.93,.02-8.23,2.12-11.51,2.38-3.71,6.16-6.37,10.62-7.48,4.43-1.1,8.98-.53,12.82,1.61,3.74,2.08,6.34,5.41,7.32,9.36,.24,.99,.39,2.01,.42,3.02,.05,1.54,.75,2.99,1.93,3.99,1.18,1,2.74,1.44,4.27,1.23l4.56-.64c2.82-.4,4.83-2.84,4.68-5.67-.1-1.9-.39-3.79-.84-5.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M213.26,158.61c.24,.99,.39,2.01,.42,3.02,.05,1.54,.75,2.99,1.93,3.98,1.18,1,2.74,1.44,4.27,1.23l4.56-.64c2.82-.4,4.83-2.84,4.68-5.67-.1-1.9-.39-3.79-.84-5.65-3.3-13.29-15.56-22.84-29.82-23.24-3.04-.09-6.09,.25-9.06,.99-8.31,2.06-15.38,7.08-19.91,14.13-4.42,6.87-5.94,14.96-4.26,22.78,.6,2.79,3.26,4.64,6.08,4.24,.03,0,.06,0,.09-.01l4.49-.71c1.46-.23,2.77-1.06,3.61-2.27,.84-1.2,1.16-2.72,.87-4.16-.78-3.93,.02-8.23,2.12-11.51,2.38-3.71,6.16-6.37,10.62-7.48,4.43-1.1,8.98-.53,12.82,1.61,3.74,2.08,6.34,5.41,7.32,9.36Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M399.05,57.88c1.24,3.74,3.78,11.44,.86,19.81-5.42,15.52-24.85,19.89-28.39,20.4-9.13,1.33-19.51,.33-29.88-3.38-26.19-9.38-42.44-32.5-36.31-51.64,3-9.37,11.09-14.5,14.15-16.39,16.98-10.5,36.68-3.33,44.13-.63,5.02,1.83,28.33,10.3,35.44,31.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M400.69,77.94c-.75,2.84-2,5.58-3.69,8.03-1.68,2.46-3.82,4.61-6.18,6.43-4.77,3.62-10.43,5.85-16.18,7.09-5.76,1.29-11.74,1.5-17.59,.96-5.86-.58-11.61-1.99-17.11-4.03-5.48-2.09-10.74-4.81-15.52-8.22-4.78-3.42-9.14-7.46-12.71-12.16-3.58-4.67-6.38-10.02-7.81-15.78-.69-2.88-1.04-5.85-.92-8.8,.11-2.95,.7-5.88,1.74-8.61,.13-.34,.51-.51,.85-.38,.32,.12,.49,.46,.41,.78h0c-1.4,5.4-1.07,11.06,.61,16.27,1.64,5.23,4.51,10.01,8,14.24,3.53,4.21,7.66,7.92,12.24,10.99,4.56,3.09,9.49,5.64,14.67,7.54,5.17,1.92,10.55,3.27,16.02,3.88,5.46,.64,10.99,.52,16.4-.43,5.39-.98,10.66-2.75,15.17-5.79,2.26-1.5,4.29-3.32,6-5.43,1.71-2.11,3.09-4.5,4.07-7.09,.16-.42,.63-.64,1.05-.48,.39,.15,.61,.58,.5,.98Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 352.76,
    cy: 60.2,
    rx: 27.81,
    ry: 38.26,
    transform: "translate(139.24 347.38) rotate(-63.05)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 346.23,
    cy: 64.77,
    rx: 20.45,
    ry: 32.43,
    transform: "translate(109.6 325.69) rotate(-58.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M316.54,62.49c-.7-1.7-1.28-3.47-1.63-5.3-.35-1.83-.49-3.72-.4-5.6,.19-3.78,1.44-7.53,3.56-10.74,2.13-3.2,5.09-5.81,8.38-7.69,3.31-1.87,6.93-3.12,10.62-3.81,3.69-.72,7.46-.86,11.18-.6,3.72,.28,7.4,.94,10.97,2,7.1,2.14,13.86,5.63,19.52,10.54,1.41,1.23,2.75,2.54,4.02,3.93,1.25,1.4,2.42,2.88,3.49,4.44,2.14,3.12,3.82,6.6,4.78,10.34,.97,3.73,1.12,7.74,.23,11.56-.86,3.82-2.82,7.38-5.47,10.19-2.65,2.83-5.94,4.94-9.43,6.34-3.49,1.41-7.17,2.22-10.85,2.49-1.84,.15-3.69,.15-5.52,.05-1.83-.09-3.65-.3-5.45-.6-1.8-.29-3.58-.7-5.33-1.2-1.75-.49-3.45-1.12-5.14-1.78-.34-.13-.51-.51-.38-.85,.13-.32,.48-.49,.8-.39h.02c3.38,1.03,6.83,1.78,10.31,2.14,1.74,.18,3.48,.28,5.22,.26,1.74-.02,3.47-.12,5.18-.37,1.71-.24,3.4-.55,5.05-1,1.65-.46,3.25-1.03,4.79-1.74,3.07-1.41,5.87-3.34,8.03-5.8,2.17-2.45,3.64-5.43,4.3-8.59,.66-3.16,.49-6.49-.41-9.65-1.79-6.36-5.96-12.05-11.12-16.44-5.17-4.43-11.34-7.73-17.9-9.72-6.53-2.04-13.51-2.75-20.22-1.7-3.35,.51-6.61,1.54-9.57,3.08-2.97,1.52-5.61,3.67-7.57,6.34-1.97,2.65-3.24,5.84-3.63,9.19-.4,3.35,.05,6.82,1.11,10.12h0c.14,.44-.1,.9-.53,1.04-.41,.13-.84-.08-1.01-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M431.22,144.45c5.66,10.64-9.58,43.03-24.02,40.84-9.48-1.15-16.13-16.95-14.31-29.62,4.59-24.86,29.52-38.46,38.33-11.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M403.79,185.25c-9.43-4.44-12-14.61-12.66-23.14-.64-11.63,3.82-24.91,15.69-31.61,1.54-.79,3.2-1.43,4.96-1.77,1.07-.23,5.95-.74,5.8,.58-.06,.24-.3,.41-.57,.42-4.76,.2-8.76,2.73-11.77,5.74-6.6,6.78-11.52,17.63-11.18,26.55,.32,7.95,2.09,17.48,10.47,22.08,.83,.39,.1,1.55-.74,1.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M400.4,160.76c.28-8.16,4.99-18.95,13.88-21.05,19.17-2.05,13.28,34.29-.47,36.67-7.92,2.29-13.78-5.05-13.41-15.62Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M423.24,154.25c-10.33,18.28-25.88,8.72-16.8-8.26,10.33-18.28,25.88-8.72,16.8,8.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M426.65,148.75c2.36,8.23,.14,18.08-6.57,24.45-7.82,7.29-17.85,3.39-20.29-5.58-2.88-9.33,.87-22.95,10.98-28.09,.98-.62,6.44-2.03,6.55-.43-.05,.26-.32,.45-.62,.44-7.58,.45-11.25,7.76-13.01,13.3-1.22,4.52-1.51,9.37-.03,13.85,1.91,6.27,7.74,9.37,13.67,4.19,6.24-5.69,8.61-14.16,7.83-21.88-.13-.79,1.29-1.01,1.5-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M398.2,281.42c3.63,5.1-6.15,20.62-15.41,19.58-6.08-.55-10.35-8.13-9.18-14.2,2.95-11.92,18.94-18.43,24.59-5.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M380.6,300.97c-6.05-2.13-7.7-7-8.12-11.09-.41-5.58,2.45-11.94,10.06-15.15,.99-.38,2.05-.69,3.18-.85,.69-.11,3.82-.35,3.72,.28-.04,.11-.19,.19-.37,.2-3.06,.1-5.62,1.31-7.55,2.75-4.23,3.25-7.39,8.45-7.17,12.73,.21,3.81,1.34,8.38,6.72,10.58,.53,.19,.07,.74-.47,.55Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M378.43,289.24c.18-3.91,3.2-9.09,8.91-10.09,12.3-.98,8.52,16.44-.3,17.58-5.08,1.1-8.84-2.42-8.6-7.49Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M393.08,286.11c-6.63,8.76-16.61,4.18-10.78-3.96,6.63-8.76,16.61-4.18,10.78,3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M395.27,283.48c1.52,3.95,.09,8.67-4.22,11.72-5.01,3.49-11.45,1.62-13.02-2.68-1.85-4.47,.56-11,7.04-13.47,.63-.3,4.13-.97,4.2-.21-.03,.13-.21,.22-.4,.21-4.87,.21-7.22,3.72-8.35,6.37-.78,2.17-.97,4.49-.02,6.64,1.22,3,4.97,4.49,8.77,2.01,4.01-2.73,5.52-6.79,5.03-10.49-.09-.38,.83-.49,.96-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M167.77,64.09c10.4-7.9,32.95,3.87,30.77,16.38-1.22,7.84-11.27,17.51-20.46,20.23-23.87,5.98-45.53-18.51-10.3-36.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M198.31,83.25c-3.09,8.53-9.49,13.44-15.38,16.73-9.11,4.84-21.59,6.3-29.74-3.34-1.07-1.42-2.01-3.08-2.59-5.02-.39-1.19-1.49-6.98,.24-7.23,.31,0,.55,.23,.58,.56,.64,5.66,3.99,9.29,7.6,11.41,7.27,4.1,17,4.56,23.92,1.16,5.55-2.74,11.61-6.81,14.77-14.61,.27-.76,.89-.41,.61,.35Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M182.15,92.32c-6.51,2.34-16.48,1.45-18.92-7.42-3.14-22.65,29.48-20.71,30.32-8.33,1.01,6.37-3.94,13.08-11.4,15.76Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M177.25,71.54c13.73,6.58,6.46,22.8-7.53,19.69-20.91-5.31-10.04-27.46,7.53-19.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M172.18,68.77c7.55-3.91,15.39-2.91,19.6,2.66,4.24,5.73,1.3,15.05-4.69,19.44-6.9,5.36-18.53,6.63-23.93-2.02-.7-.87-2.47-6.6-.71-7.19,.29-.02,.5,.24,.51,.58,.75,8.25,8,9.58,12.9,9.5,3.7-.26,7.42-1.43,10.72-3.99,4.34-3.23,6.64-8.99,3.48-13.35-3.85-5.06-10.62-6.16-17.64-3.98-.76,.3-.99-1.28-.24-1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M276.34,373.8c-12.11,9.19-38.34-4.51-35.8-19.07,1.42-9.12,13.12-20.37,23.81-23.55,27.77-6.96,52.98,21.54,11.99,42.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M240.81,351.51c3.59-9.92,11.04-15.64,17.9-19.46,10.6-5.64,25.12-7.33,34.61,3.89,1.25,1.66,2.34,3.59,3.02,5.85,.45,1.38,1.74,8.12-.28,8.41-.36,0-.63-.27-.68-.65-.75-6.58-4.64-10.81-8.84-13.27-8.46-4.77-19.79-5.31-27.83-1.35-6.46,3.19-13.52,7.92-17.18,17.01-.32,.88-1.03,.47-.71-.41Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M259.6,340.95c7.58-2.72,19.18-1.69,22.02,8.64,3.66,26.36-34.31,24.1-35.28,9.69-1.17-7.41,4.58-15.22,13.26-18.33Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M265.31,365.13c-15.98-7.65-7.51-26.53,8.77-22.92,24.33,6.18,11.68,31.95-8.77,22.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M271.21,368.36c-8.78,4.56-17.9,3.39-22.81-3.09-4.94-6.67-1.52-17.51,5.46-22.63,8.03-6.24,21.56-7.71,27.85,2.36,.82,1.01,2.88,7.68,.82,8.37-.34,.02-.59-.28-.59-.68-.87-9.6-9.31-11.15-15.01-11.05-4.3,.3-8.64,1.67-12.47,4.64-5.05,3.76-7.72,10.46-4.05,15.54,4.49,5.89,12.36,7.17,20.52,4.63,.88-.35,1.15,1.49,.28,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M112.28,305.23c-14.18-5.26-31.78-46.88-18.41-56.26,8.53-6.42,28.2,2.79,38.36,15.8,19.11,26.34,11.9,58.41-19.95,40.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M96.6,246.32c11.49-3.37,22.81,3.9,31.12,11.17,11.14,10.13,19.76,25.77,16.53,41.25-.49,1.93-1.21,3.83-2.29,5.53-.63,1.06-4.02,5.37-5.1,4.03-.17-.27-.13-.61,.07-.83,3.57-3.94,4.41-9.4,4.03-14.53-1-11.4-7.04-25.19-15.46-33.08-7.52-7.02-17.63-14.33-28.44-11.93-1.01,.3-1.5-1.33-.47-1.63Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M121.65,266.04c7.23,7.68,13.4,21.25,8.3,30.18-13.23,16.98-41.82-20.88-33.15-33.89,4.15-8.34,15.47-6.24,24.85,3.71Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M109.61,289.99c-8.57-24.85,12.43-28.36,20.79-5.69,8.57,24.85-12.43,28.36-20.79,5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M111.95,297.7c-9.39-5.66-16.64-16.42-17.17-27.53-.5-12.82,10.97-17.16,21.09-10.88,10.8,6.26,20.29,21.66,17.03,34.33-.2,1.34-3.22,6.93-4.77,5.55-.2-.28-.16-.67,.08-.9,5.57-6.38,1.78-15.96-1.9-22.4-3.17-5.09-7.38-9.75-12.64-12.68-7.23-4.23-14.67-2.47-14.6,6.94,.28,10.12,6.16,19.73,13.83,26.17,.82,.61-.09,1.94-.96,1.4Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M475.23,211.3l-126.97,52.22c6.27-3.37,12.43-6.74,18.49-10.12,34.04-18.94,64.75-37.88,91.06-56.26,2.15-1.49,4.25-2.99,6.33-4.46,1.64-1.18,5.42-4.07,8.31-6.28,1.11,6.4,1.92,12.9,2.43,19.49,.14,1.8,.26,3.6,.34,5.42Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M509.74,309.87c10.63,14.19,13.52,26.03,8.59,35.18-4.92,9.16-16.89,14.2-35.57,14.99-14.39,.61-32.66-1.24-54.41-5.5-.28-.05-.57-.11-.85-.17-2.55-.51-5.16-1.04-7.81-1.61-5.75-1.25-11.67-2.63-17.72-4.14-.48-.12-.96-.24-1.45-.36-7.3-1.85-14.8-3.9-22.48-6.13-43.07-12.51-91.61-30.86-140.65-53.27-35.56-16.25-69.1-33.61-98.91-51.09-3.91-2.29-7.76-4.59-11.53-6.88-20.59-12.51-39.17-25.01-55.08-37.14-1.3-.98-2.57-1.97-3.83-2.94-1.43-1.11-2.83-2.22-4.2-3.32-16.23-13-28.45-24.95-36.43-35.61-10.62-14.19-13.51-26.02-8.59-35.18,4.92-9.16,16.89-14.2,35.58-14.99,11.71-.5,25.99,.64,42.62,3.37-2.38,3.49-4.66,7.05-6.82,10.69-38.3-5.74-56.25-1.12-60.12,6.07-4.1,7.64,3.86,25.12,36.44,52.34,1.16,.96,2.34,1.94,3.56,2.93,3.06,2.49,6.33,5.06,9.8,7.7,16.76,12.78,36.56,25.99,58.61,39.19,3.83,2.29,7.74,4.59,11.71,6.88,28.16,16.27,59.57,32.41,92.78,47.59,8.56,3.91,17.1,7.7,25.6,11.35,8.5-3.65,17.04-7.44,25.6-11.35,28.74-13.14,56.14-27,81.26-41.04,3.9-2.18,7.75-4.37,11.53-6.56,.14-.07,.27-.15,.39-.22,3.83-2.22,7.61-4.44,11.32-6.66,14.68-8.79,28.37-17.58,40.82-26.25,3.33-2.32,6.57-4.62,9.72-6.92,2.76-2.01,5.45-4.02,8.07-6.01,3.47-2.64,6.73-5.21,9.8-7.7,1.22-.99,2.41-1.97,3.56-2.93,32.58-27.22,40.54-44.7,36.44-52.34-3.87-7.19-21.82-11.81-60.12-6.07-2.16-3.64-4.44-7.2-6.82-10.69,16.63-2.74,30.91-3.87,42.62-3.37,18.68,.79,30.65,5.83,35.57,14.99,4.93,9.16,2.04,20.99-8.59,35.18-7.97,10.66-20.2,22.61-36.43,35.61-1.37,1.1-2.78,2.21-4.2,3.32-1.26,.97-2.53,1.96-3.83,2.94-4.51,3.44-9.24,6.91-14.16,10.39-3.64,2.58-7.38,5.17-11.23,7.77-9.32,6.29-19.25,12.63-29.69,18.97-.03,.02-.07,.05-.11,.07-7.06,3.92-37.94,21.93-45,25.84l-81.56,39.34c36.74,15.19,72.33,27.7,104.52,36.73,7.33,2.06,14.49,3.93,21.44,5.62,1.07,.27,2.13,.52,3.19,.77,3.35,.79,6.65,1.54,9.89,2.24,4.84,1.04,9.45,1.96,13.83,2.75,45.61,8.28,66.48,3.51,70.69-4.32,4.27-7.93-4.52-26.52-40.42-55.61,1.29-4.12,2.47-8.29,3.51-12.52,17.8,13.96,31.1,26.76,39.58,38.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M254.49,308.43c-39.43,16.12-77.49,29.15-111.49,38.15-2.63,.7-5.24,1.37-7.82,2.02-1.07,.27-2.14,.53-3.19,.79-4.94,1.21-9.79,2.33-14.53,3.36-2.65,.57-5.26,1.11-7.81,1.61-.28,.05-.57,.11-.85,.17-21.75,4.26-40.02,6.11-54.41,5.5-18.68-.79-30.65-5.83-35.58-14.99-4.92-9.15-2.03-20.99,8.59-35.18,8.49-11.34,21.79-24.14,39.58-38.1,1.04,4.22,2.21,8.4,3.51,12.52-35.9,29.09-44.69,47.68-40.42,55.61,4.21,7.82,25.08,12.6,70.69,4.32,4.38-.79,8.98-1.71,13.83-2.75,2.93-.64,5.91-1.31,8.92-2.01,.32-.07,.64-.15,.96-.23,2.56-.61,5.16-1.24,7.78-1.91,32.42-8.15,69.02-20.28,107.19-35.46,5.02,2.23,10.04,4.43,15.04,6.58Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSimple);
export default __webpack_public_path__ + "static/media/logo-simple.016fe09c0c0d6a3d5d45b29d376043d0.svg";
export { ForwardRef as ReactComponent };